import { useState, useEffect } from 'react';
import apiRequest from "@services/apiRequest";
import {LogoSchema} from "../types";

export const useLogo = () => {

  const [loading, setLoading] = useState<boolean>(false);
  const getLogo = async (userId?:number) => {
    setLoading(true);
    const response = await apiRequest.get(`/users/get_logo`, (userId ? {params: {uid:userId}} : {}));
    setLoading(false);
    if (response){
      return {
        url: response.url,
        filename: response.filename,
        loadedOn: new Date(response.loaded_on),
      }
    } else {
      return undefined
    }
  }

  const updateLogo = async (
    newLogo: LogoSchema
  ) => {
    setLoading(true);
    await apiRequest.post(
      `/users/update_logo`,
      newLogo
    )
    setLoading(false);
  }

  const deleteLogo = async () => {
    setLoading(true)
    await apiRequest.delete(
      `/users/delete_logo`,
    )
    setLoading(false)
  }

  return {
    loading,
    getLogo,
    updateLogo,
    deleteLogo,
  };
}